"use client";

import { c as _c } from "react/compiler-runtime";
import MobileWrapperDialog from "@/components/mobile-wrapper-dialog/MobileWrapperDialog";
import type { SelectableIdentityOption } from "@/components/utils/input/profile-search/getSelectableIdentity";
import { ApiWaveParticipationIdentitySubmissionWhoCanBeSubmitted } from "@/generated/models/ApiWaveParticipationIdentitySubmissionWhoCanBeSubmitted";
import CreateDropIdentityPickerContent from "./CreateDropIdentityPickerContent";
interface CreateDropIdentityPickerModalProps {
  readonly isOpen: boolean;
  readonly mode: ApiWaveParticipationIdentitySubmissionWhoCanBeSubmitted;
  readonly selectedIdentity: SelectableIdentityOption | null;
  readonly disabled: boolean;
  readonly errorMessage: string | null;
  readonly canClose: boolean;
  readonly onClose: () => void;
  readonly onSelect: (selection: SelectableIdentityOption) => void;
}
export default function CreateDropIdentityPickerModal(t0) {
  const $ = _c(11);
  const {
    isOpen,
    mode,
    selectedIdentity,
    disabled,
    errorMessage,
    canClose,
    onClose,
    onSelect
  } = t0;
  let t1;
  if ($[0] !== disabled || $[1] !== errorMessage || $[2] !== mode || $[3] !== onSelect || $[4] !== selectedIdentity) {
    t1 = <div className="tw-px-4 sm:tw-px-6"><CreateDropIdentityPickerContent mode={mode} selectedIdentity={selectedIdentity} disabled={disabled} errorMessage={errorMessage} onSelect={onSelect} /></div>;
    $[0] = disabled;
    $[1] = errorMessage;
    $[2] = mode;
    $[3] = onSelect;
    $[4] = selectedIdentity;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== canClose || $[7] !== isOpen || $[8] !== onClose || $[9] !== t1) {
    t2 = <MobileWrapperDialog title="Select identity" isOpen={isOpen} onClose={onClose} dismissible={canClose} tabletModal={true} allowOverflow={true} maxWidthClass="md:tw-max-w-xl">{t1}</MobileWrapperDialog>;
    $[6] = canClose;
    $[7] = isOpen;
    $[8] = onClose;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
}